import Swal from "sweetalert2";
import Config from "./config/constants";

$(document).on('turbolinks:load', () => {
    let personnel_zones_table = $("#personnel-zones-table");
    if (personnel_zones_table) {
        listenForMouseOver();
        listenForClick();
    }
})

function listenForClick() {
    $('.non-alerting-personnel-zone').on("click", function() {
        Swal.fire({
            title: 'Are you sure?',
            text: "Are you sure you want to make this an alerting zone? This means the next time personnel check out a TeamSense, they will receive audible and visual alerts when entering the zone.",
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                let zone_id = $(this).data('zone-id');
                $.ajax({
                    type: 'PUT',
                    url: `/api/v2/geofences/convert_to_alerting_zone?apikey=${Config.apiKey}&zone_id=${zone_id}`,
                    dataType: "json",
                    success: data => {
                        Swal.fire('Successfully converted to an alerting zone.');
                        location.reload();
                    }
                })
            }
        })
    })
}

function listenForMouseOver() {
    $('.non-alerting-personnel-zone').on("mouseenter", function() {
        $(this).text('Make Alerting');
        $(this).css('cursor', 'pointer');
        $(this).removeClass('green-cell');
        $(this).addClass('personnel-zone-convert');
    })

    $('.non-alerting-personnel-zone').on("mouseleave", function() {
        $(this).text('Not Alerting');
        $(this).css('cursor', 'default');
        $(this).addClass('green-cell');
        $(this).removeClass('personnel-zone-convert');
    })
}